module.exports = __webpack_public_path__ + "static/media/trial_bg.dcfd5b42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/trial_bg.jpg
// module id = 244
// module chunks = 0